import React, { useEffect, useRef, useState } from 'react';
import Button from 'devextreme-react/button';
import icons from '../../common/icons/icons';
import { useTranslation } from 'react-i18next';
import EditFleetVesselListGrid from '../edit-my-watch-list-grid/EditMyWatchListGrid';
import { IFleetVesselObject } from '../../../types/list';
import { MarsApiConfig as apiConfig } from '../../../api/mars-api-config';
import { MarsApiService as api } from '../../../api/mars-api-service';
import EditFleetVessel from '../edit-fleet-vessel/EditFleetVessel';
import { Restricted } from '../../../contexts/PermissionContext';
import ExcelUploadFleetVessel from '../excel-upload-to-fleetList/ExcelUploadFleetVessel';

export default function FleetVesselList(props: {
  fleetId: any;
  getMyWatchListById: any;
  fleetName: string;
}) {
  const { fleetId, getMyWatchListById, fleetName } = props;
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();
  const [isExceUpload, setIsExcelUpload] = useState(false);
  const [fleetVesselList, setFleetVesselList] =
    useState<IFleetVesselObject | null>(null);
  const entriesGridRef = useRef<any>();

  useEffect(() => {
    if (!fleetId) return;
    getFleetVesselList();
  }, [fleetId]);

  const getFleetVesselList = async () => {
    try {
      const data = await api.get({ url: apiConfig.fleetVesselList + fleetId });
      setFleetVesselList(data);
    } catch (err) {
      console.error('Error fetching myWatchList:', err);
    }
  };

  const handleCancelClick = () => {
    setIsExcelUpload(false);
  };

  const handleGetFleetByIdFromExcel = () => {
    getFleetVesselList();
  };
  return (
    <>
      <div className="m-l-inner-page-body-wrap">
        <div className="m-l-inner-page-sub-header m-l-sub-head-top">
          <div className="m-l-inner-page-sub-header-left-block">
            <div className="m-l-page-main-heading">{t('headers.vessels')}</div>
          </div>
          <div className="m-l-inner-page-sub-header-right-block">
            <Button
              className="app-c-btn app-c-btn--secondary m-c-icon-inside-secondary-button"
              aria-label="Upload"
              onClick={() =>
                entriesGridRef.current.exportListEntriesGrid(fleetName)
              }
            >
              <div className="m-c-icon-inside-btn">
                <icons.download />
              </div>
            </Button>
            <Restricted permission="MyWatchList.ImportVessels">
              <Button
                className="app-c-btn app-c-btn--secondary m-c-icon-inside-secondary-button"
                aria-label="Upload"
                onClick={() => {
                  setIsExcelUpload(true);
                }}
              >
                <div className="m-c-icon-inside-btn">
                  <icons.IconUpload />
                </div>
              </Button>
            </Restricted>
            <Restricted permission="MyWatchList.AddVessels">
              <Button
                className="app-c-btn app-c-btn--primary min-btn-width"
                onClick={() => {
                  setIsVisible(true);
                }}
              >
                {t('buttons.addNew')}
              </Button>
            </Restricted>
          </div>
        </div>
        {fleetVesselList && (
          <EditFleetVesselListGrid
            fleetVesselList={fleetVesselList}
            ref={entriesGridRef}
            setFleetVesselId={() => getFleetVesselList()}
          />
        )}
      </div>
      {isVisible ? (
        <EditFleetVessel
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          fleetId={fleetId}
          getFleetById={() => getFleetVesselList()}
        />
      ) : null}
      {isExceUpload ? (
        <ExcelUploadFleetVessel
          isVisible={isExceUpload}
          handleCancelClick={handleCancelClick}
          fleetId={fleetId}
          getFleetById={handleGetFleetByIdFromExcel}
        />
      ) : null}
    </>
  );
}
